import Signal from "libs/signals";

const businessFundsSignal = Signal({
  funds: [],
  fundRequests: [],
});

export default businessFundsSignal;
